module.exports = __webpack_public_path__ + "img/Installer.23dc29b6.png";